import React from "react";
import { useDateTime } from "../utils/hooks";
export var TimeSwitch = function (_a) {
    var _b;
    var children = _a.children;
    var now = useDateTime("minute");
    return ((_b = children.find(function (child) {
        return new Date(child.starts) < now
            && new Date(child.ends) > now;
    })) === null || _b === void 0 ? void 0 : _b.content) || children[0].content || React.createElement("h1", null, "Something went wrong. If you feel helpful, please refresh the page and let the helpdesk know!");
};
//# sourceMappingURL=TimeSwitch.js.map